import { useCallback } from 'react';
import { marketplaceIntegration } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import useDebouncedState from '../../../../../hooks/useDebouncedState';
import { LOCATION, TEXT_FIELDS } from '../../../bi/mixpanel/constants';
import { BRAND_NAME_PROP, SLOGAN_PROP } from '../../shared/constants';

const { reportTextFieldsChanged } = marketplaceIntegration;

const useStickyFilters = ({ briefData, setBriefData }) => {
    const [brandState, setBriefBrand] = useDebouncedState(
        briefData,
        setBriefData
    );
    const [sloganState, setBriefSlogan] = useDebouncedState(
        briefData,
        setBriefData
    );

    const handleBrandNameChange = useCallback(
        ({ currentTarget }) => {
            setBriefBrand({ [BRAND_NAME_PROP]: currentTarget.value });
            reportTextFieldsChanged({
                location: LOCATION.STICKY,
                field: TEXT_FIELDS.BRAND_NAME,
            });
        },
        [setBriefBrand]
    );

    const handleSloganChange = useCallback(
        ({ currentTarget }) => {
            setBriefSlogan({ [SLOGAN_PROP]: currentTarget.value });
            reportTextFieldsChanged({
                location: LOCATION.STICKY,
                field: TEXT_FIELDS.SLOGAN,
            });
        },
        [setBriefSlogan]
    );

    return {
        handleBrandNameChange,
        handleSloganChange,
        brandName: brandState[BRAND_NAME_PROP],
        slogan: sloganState[SLOGAN_PROP],
    };
};

export default useStickyFilters;
